import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

// import ConsultationFloatingWidget from 'src/components/ConsultationFloatingWidget';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const ResikoJantung = dynamic(() => import('src/containers/ResikoJantung'));

const ResikoJantungPage = (props: any) => {
	return (
		<>
			<HeadC
				title="Cek Risiko Penyakit Jantung - Health Tools KlikDokter"
				description={
					'Cek risiko penyakit jantung sebagai langkah pencegahan serangan ' +
					'jantung yang berbahaya. Periksa secara online lewat Health Tools KlikDokter.'
				}
				pageItem={props.imageMenuCategory[0]}
				hideSuffix
			/>
			<ResikoJantung {...props} />

			{/* <ConsultationFloatingWidget /> */}
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	const menu: any = await store.dispatch(actionGetMenu());
	const menuOptions = menu?.data?.record?.deteksi_menu;
	const filterMenuSelection = menuOptions.filter((item: any) => item.deeplink === '/jaga-jantung');
	const dataImage = filterMenuSelection?.map((item: any) => item.icon);

	return {
		props: {
			imageMenuCategory: dataImage,
		},
	};
});

export default ResikoJantungPage;
